module.exports = __webpack_public_path__ + "img/arrow-down.bb197cfd.svg";